import {AbstractDataServiceV2} from '../../../../core/service/v2/dataservice/abstractDataServiceV2';
import {CustomizeHttpUrlGenerator} from '../../../../../store/core/url/customizeHttpUrlGenerator';
import {HttpClient} from '@angular/common/http';
import {DefaultDataServiceConfig, Logger} from '@ngrx/data';
import {Injectable} from '@angular/core';
import {PartnerNote} from '../api/entity/partnerNote.model';
import {PartnerNoteConverter} from '../api/converter/partnerNote.converter';

@Injectable({
    providedIn: 'root'
})
export class NoteDataService extends AbstractDataServiceV2<PartnerNote, PartnerNoteConverter> {
    constructor(http: HttpClient, httpUrlGenerator: CustomizeHttpUrlGenerator,
                logger: Logger, config: DefaultDataServiceConfig,
                converter: PartnerNoteConverter) {
        super('Note', http, httpUrlGenerator, logger, config, converter);
    }
}
